import storage from '@/utils/storage';

const MobileLayout = () => import('@/components/mobile/layout.vue');
const MobileQuestion = () => import('@/components/mobile/wenda/index.vue');
const MobileQuestionDetail = () => import('@/components/mobile/wenda/detail.vue');
const MobileQuestionAdd = () => import('@/components/mobile/wenda/add.vue');
const MobileProduct = () => import('@/components/mobile/product/index.vue');
const MobileUser = () => import('@/components/mobile/user/index.vue');
const MobileUserRights = () => import('@/components/mobile/user/rights.vue');
const MobileNetworkManage = () => import('@/components/mobile/user/network.vue');
const MobileOrders = () => import('@/components/mobile/user/orders.vue');
const MobileInvoiceManage = () => import('@/components/mobile/user/invoice.vue');
const MobileMessages = () => import('@/components/mobile/user/messages.vue');
const MobileMyAnswers = () => import('@/components/mobile/user/my-answers.vue');
const MobileLogin = () => import('@/components/mobile/login/index.vue');

export default [
    {
        path: '/login',
        component: MobileLogin,
    },
    {
        path: '/',
        component: MobileLayout,
        redirect: '/index',
        children: [
            {
                path: 'index',
                component: MobileQuestion,
            },
            {
                path: 'index/search',
                component: MobileQuestion,
            },
            {
                path: 'wenda',
                redirect: '/wenda/index',
            },
            {
                path: 'wenda/:type',
                component: MobileQuestion,
            },
            {
                path: 'wenda/detail/:id',
                component: MobileQuestionDetail,
            },
            {
                path: 'add',
                component: MobileQuestionAdd,
                meta: {hideMobileTabBar: true},
                beforeEnter(to, from, next) {
                    if (storage.token()) {
                        next();
                        return;
                    }
                    next({path: '/login', query: {redirect: to.fullPath}});
                },
            },
            {
                path: 'product',
                component: MobileProduct,
            },
            {
                path: 'user',
                redirect: '/user/profile/setting',
            },
            {
                path: 'user/profile/setting',
                component: MobileUser,
                beforeEnter(to, from, next) {
                    if (storage.token()) {
                        next();
                        return;
                    }
                    next({path: '/login', query: {redirect: to.fullPath}});
                },
            },
            {
                path: 'user/buy/auth',
                component: MobileUserRights,
                beforeEnter(to, from, next) {
                    if (storage.token()) {
                        next();
                        return;
                    }
                    next({path: '/login', query: {redirect: to.fullPath}});
                },
            },
            {
                path: 'user/buy/net',
                component: MobileNetworkManage,
                beforeEnter(to, from, next) {
                    if (storage.token()) {
                        next();
                        return;
                    }
                    next({path: '/login', query: {redirect: to.fullPath}});
                },
            },
            {
                path: 'user/buy/list',
                component: MobileOrders,
                beforeEnter(to, from, next) {
                    if (storage.token()) {
                        next();
                        return;
                    }
                    next({path: '/login', query: {redirect: to.fullPath}});
                },
            },
            {
                path: 'user/buy/invoice',
                component: MobileInvoiceManage,
                beforeEnter(to, from, next) {
                    if (storage.token()) {
                        next();
                        return;
                    }
                    next({path: '/login', query: {redirect: to.fullPath}});
                },
            },
            {
                path: 'user/profile/message',
                component: MobileMessages,
                beforeEnter(to, from, next) {
                    if (storage.token()) {
                        next();
                        return;
                    }
                    next({path: '/login', query: {redirect: to.fullPath}});
                },
            },
            {
                path: 'user/answer/my',
                component: MobileMyAnswers,
                beforeEnter(to, from, next) {
                    if (storage.token()) {
                        next();
                        return;
                    }
                    next({path: '/login', query: {redirect: to.fullPath}});
                },
            },
        ],
    },
    {
        path: '*',
        redirect: '/index',
    },
];
